import { createRouter, createWebHistory } from "vue-router";
import LoginPage from "../components/LoginPage.vue";
import RegisterPage from "../components/RegisterPage.vue";
import DashboardPage from "../components/DashboardPage.vue";
import Thank from "@/components/Thank.vue";
// src/router/index.js
const routes = [
  { path: "/", component: RegisterPage },   // Root pe register page
  { path: "/login", component: LoginPage },
  { path: "/dashboard", component: DashboardPage },
  { path: "/", component: RegisterPage },
  {path: "/register/thankyou", component : Thank}
  // Optional: ab bhi /register accessible rahe
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
